export const getFileWindow = (callBack: (file: File | undefined) => void, options?: {accept: string}) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = options?.accept || '';
  input.onchange = () => callBack(input.files?.[0]);
  input.click();
};
